module.exports = __webpack_public_path__ + "img/golf.a94cafd8.png";